import { jsx as e } from "react/jsx-runtime";
import { useTranslation as n } from "../../i18n.mjs";
import { FileSelector as f } from "./file-selector.mjs";
import { Modal as s, ModalSizeEnum as a } from "@systemeio/ui";
function M({
  title: o,
  opened: r,
  onClose: i,
  onSelect: t,
  ...l
}) {
  const { t: m } = n();
  return /* @__PURE__ */ e(
    s,
    {
      title: o ?? m("file_manager.file_selector.choose_file"),
      opened: r,
      isCentered: !0,
      size: a.big,
      onClose: i,
      children: /* @__PURE__ */ e(f, { onSelect: t, ...l })
    }
  );
}
export {
  M as FileSelectorModal
};
